import { withCompInfo } from '@wix/editor-elements-integrations'
import type { CompInfo } from '@wix/thunderbolt-becky-root'
import { getScaledFont, fontObjectToString, parseFontStr } from '@wix/thunderbolt-becky-root'
import type { PaginationDefinition, PaginationCssCarmiData } from '@wix/thunderbolt-components-native'

const MAX_FONT_SIZE_WITH_NAV_BUTTONS = {
	pages: 15,
	input: 11,
	arrows: 15,
}

const MAX_FONT_SIZE = {
	pages: 24,
	input: 16,
	arrows: 24,
}
/**
 * IMPORTANT! do not try to make sense out the following code, it is probably a bug that got into production and now
 * cannot be fixed since it will affect existing website layouts.
 *************************************************************************************************************************
 * This method is extending the implementation of the core `getScaledFont` in order to align to the same calculations made
 * for this component in wix-ui-santa. (https://github.com/wix-private/wix-ui-santa/blob/master/src/components/Pagination/Pagination.js#L123)
 * The main addition here is that it applies a second scaling on the final value received from `getScaledFont`.
 * In case this value exceeds a custom max-value it will return the scaled max-value instead.
 **/
function getMobileScaledFont(
	compProps: PaginationDefinition['property'] & { fontScale?: number },
	compLayout: CompInfo['compLayout'],
	font: string
): string {
	const { paginationMode, showFirstLastNavButtons } = compProps

	const scale = compProps?.fontScale ?? compLayout?.scale ?? 1

	const fontObject = parseFontStr(font)
	const fontSize = fontObject.size
	const maxFontSize = showFirstLastNavButtons
		? MAX_FONT_SIZE_WITH_NAV_BUTTONS[paginationMode]
		: MAX_FONT_SIZE[paginationMode]

	const scaledFontSize = (fontSize > maxFontSize ? maxFontSize : fontSize) * scale
	return fontObjectToString({ ...fontObject, size: scaledFontSize })
}

export const css = withCompInfo<PaginationCssCarmiData, PaginationDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'compProps', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, compProps, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const scaledFont = getScaledFont(compInfo, 'fnt', isOneDocMigrated)
		return {
			'--fnt': isMobileView ? getMobileScaledFont(compProps, compLayout, scaledFont) : scaledFont,
			height: 'auto',
		}
	}
)
